import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateFormatPipe } from './date-format.pipe';
import { FillPipe } from './fill.pipe';
import { KeysortPipe } from './keysort.pipe';
import { listLimitPipe } from './list-limit.pipe';
import { NumberLabelPipe } from './number-label.pipe';
import { OrganizationsToPersonsPipe } from './organizations-to-persons.pipe';
import { PersonRoutePipe } from './person-route.pipe';
import { SafeHtmlPipe } from './safehtml.pipe';
import { SecondsToMinutesPipe } from './seconds-to-minutes.pipe';
import { StriptagsPipe } from './striptags.pipe';
import { SubstringPipe } from './substring.pipe';
import { TimeFormatPipe } from './time-format.pipe';
import { TrackTimePipe } from './track-time.pipe';
import { TruncatePipe } from './truncate.pipe';

const IO_MODULES = [
  SafeHtmlPipe,
  DateFormatPipe,
  listLimitPipe,
  TimeFormatPipe,
  FillPipe,
  NumberLabelPipe,
  SecondsToMinutesPipe,
  TrackTimePipe,
  PersonRoutePipe,
  TruncatePipe,
  StriptagsPipe,
  SubstringPipe,
  KeysortPipe,
  OrganizationsToPersonsPipe
];

@NgModule({
  declarations: [...IO_MODULES],
  exports: [...IO_MODULES],
  providers: [DatePipe]
})
export class PipesModule {}
